//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

// 业务订单列表
const businessOrderList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/businessOrder/list.vue')),
    'businessOrderList'
  );
const businessOrderAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/businessOrder/add.vue')),
    'businessOrderAdd'
  );
const businessOrderDetail = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/businessOrder/detail.vue')),
    'businessOrderDetail'
  );

const businessOrderRouter = {
  path: '/businessOrder',
  component: index,
  children: [
    {
      path: 'list',
      name: 'businessOrderList',
      component: businessOrderList,
      meta: {
        keepAlive: true,
        title: '业务订单列表',
      },
    },
    {
      path: 'add',
      name: 'businessOrderAdd',
      component: businessOrderAdd,
      meta: {
        keepAlive: true,
        title: '新建业务订单关联',
      },
    },
    {
      path: 'detail',
      name: 'businessOrderDetail',
      component: businessOrderDetail,
      meta: {
        keepAlive: true,
        title: '业务订单详情',
      },
    },
  ],
};
export default businessOrderRouter;
